import {React, useEffect, useState} from 'react';
import Cv from './CV.pdf'
import { click } from '@testing-library/user-event/dist/click';

 

const IMAGES = {
    linkEd: require("./Iconhead/Social.svg").default,
    twitter: require("./Iconhead/Social-1.svg").default,
    gitHub: require("./Iconhead/Social-2.svg").default,
    telegram: require("./Iconhead/Social-3.svg").default,
    youTube: require("./Iconhead/Social-4.svg").default,
    instagram: require("./Iconhead/Social-5.svg").default,
    hand: require("./Iconhead/Light-brown-in-Basic.png"),
}

const Head = () => {
        const [downloaded,setDownloaded] = useState("CV is the downloaded")
        const onClick = downloaded =>{
            setDownloaded(downloaded)
        }
     useEffect(()=>{
           let evenet = document.createElement("div")
           
            evenet.classList.add("evenetion")
            if (onClick == onclick) {
                evenet.innerHTML += `<div>Download</div>`
            }
           document.body.appendChild(evenet)
           setTimeout(() => {
                document.body.removeChild(evenet)   
           }, 2000);
     }, [downloaded])
    return ( 
        <div className='head' name='/'>
            <img src={ IMAGES.hand} alt="" className='left_hand' data-aos="fade-right" />
            <div className='head_text'>
                <h1 data-aos="fade-right">I’m Shakhriddin Achilov</h1>
                <p data-aos="fade-right" data-aos-delay='100'><span>Frontend Developer and Designer</span>. I learn and<br /> teach everything about Web Technologies<br /> and Product Design.</p>
                <div className='social_networks_cv'>
                    <div data-aos="fade-right" data-aos-delay='200' className='social_network'>
                        <a href='https://www.linkedin.com/in/shax-achilov'>
                            <img src={IMAGES.linkEd} /> 
                        </a>
                        <a href='https://t.me/achilovshax'>
                            <img src={IMAGES.twitter} />
                        </a>
                        <a href='https://github.com/shaxuzb'>
                            <img src={IMAGES.gitHub} />
                        </a>
                        <a href='https://t.me/achilovshax'>
                            <img src={IMAGES.telegram} />
                        </a>
                        <a href='https://www.youtube.com/@richboypubgm1'>
                             <img src={IMAGES.youTube} />
                        </a>
                        <a href='https://www.instagram.com/shaxiachilov_1'>
                            <img src={IMAGES.instagram} />
                        </a>
                    </div>
                    <div className='cv_head' data-aos="fade-left" data-aos-delay='200'>
                        <a href={Cv} target='_blank' download onClick={()=>{onClick("Downloaded")}}>
                        <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 5V16.5C9.5 18.71 7.71 20.5 5.5 20.5C3.29 20.5 1.5 18.71 1.5 16.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V16.5C0 19.54 2.46 22 5.5 22C8.54 22 11 19.54 11 16.5V5H9.5Z" fill="#211B12"/>
                        </svg>
                            Download CV
                        </a>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Head;